import React from 'react'
import { Award, Eye, CheckCircle, User, Calendar} from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { formatearFechaCorta } from '../../../utils/utils';
import { useisUserAdmin, useisUserCliente, useisUserTutor } from '../../../config/unificacion';
import { useUsers } from '../../../metodos/userContext';
import { GeneralRoutes } from '../../../utils/navigator';

const CardServicio = ({
  servicio,
}) => {
  const navigate = useNavigate();
  const { usuario, loadingUsuario, errorUsuario } = useUsers();
  const isAdmin = useisUserAdmin(usuario);
  const isTutor = useisUserTutor(usuario);
  const isCliente = useisUserCliente(usuario);


  const handleVerServicio = (servicio) => {
    // Navegar a detalles de solicitud
    GeneralRoutes.irADetalleServicio(navigate, servicio);
  };

  return (
    <div className="bg-white border border-gray-200 rounded-lg p-4 hover:shadow-md transition-shadow mb-3">

      {/* CABECERA: Común para todos pero con datos filtrados */}
      <div className="flex items-start justify-between mb-3">
         {/* Datos principales, codigo, materia, nombre empresa*/}
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center">
            <CheckCircle className="w-4 h-4 text-green-600" />
          </div>
          <div>
            <h4 className="font-semibold text-gray-900 text-sm">{servicio.codigo}</h4>
            <p className="text-xs text-gray-600">{servicio.materia}</p>
            {!isCliente && <p className="text-[10px] text-blue-500 font-bold uppercase">{servicio.nombreEmpresa}</p>}          </div>
        </div>
        {/* Precio Inversión / precio de tutor */}
        <div className="text-right">
          <p className="text-sm font-extrabold text-green-600">
            {/* El cliente ve el precio total, el tutor ve su pago */}
            {isTutor 
              ? `$${servicio.preciotutor?.toLocaleString()}` 
              : `$${servicio.preciocobrado?.toLocaleString()}`}
          </p>
          <p className="text-[10px] text-gray-400 uppercase font-bold">
            {isTutor ? 'Tu Pago' : 'Inversión'}
          </p>
        </div>
      </div>
      
      {/* CUERPO: Información específica del rol */}
      <div className="grid grid-cols-2 gap-4 mb-4 text-xs p-3 bg-gray-50 rounded-lg">
        
        {/* Tutor Asignado */}
        {!isCliente && (
          <div>
            <p className="text-gray-400 font-semibold mb-1 uppercase text-[9px]">Tutor Asignado</p>
            <div className="flex items-center gap-1 text-gray-700">
              <User size={12} className="text-gray-400" />
              <span className="font-medium">{servicio.tutor || 'Pendiente'}</span>
            </div>
          </div>
        )}

        {/* Fecha de entrega */}
        <div>
          <p className="text-gray-400 font-semibold mb-1 uppercase text-[9px]">Fecha Entrega</p>
          <div className="flex items-center gap-1 text-gray-700">
            <Calendar size={12} className="text-gray-400" />
            <span className="font-medium">{formatearFechaCorta(servicio.fechaentrega)}</span>
          </div>
        </div>

        {/* Fecha de sistema */}
        {isAdmin && (
          <div>
            <p className="text-gray-400 font-semibold mb-1 uppercase text-[9px]">Fecha sistema</p>
            <div className="flex items-center gap-1 text-gray-700">
              <Calendar size={12} className="text-gray-400" />
              <span className="font-medium">{formatearFechaCorta(servicio.fechasistema)}</span>
            </div>
          </div>
        )}

        {/* Id de solicitud */}
        <div>
          <p className="text-gray-400 font-semibold mb-1 uppercase text-[9px]">Id solicitud</p>
          <div className="flex items-center gap-1 text-gray-700">
            <Calendar size={12} className="text-gray-400" />
            <span className="font-medium">{servicio.idsolicitud}</span>
          </div>
        </div>

      </div>
      
      {/* FOOTER: Acciones y datos sensibles */}
      <div className="flex items-center justify-between gap-3">
        <div className="flex items-center gap-2">
          <span className={`px-2 py-1 rounded-md text-[10px] font-bold uppercase ${
            servicio.getTrabajoEntregado() 
              ? "bg-green-100 text-green-700" 
              : "bg-amber-100 text-amber-700"
          }`}>
            {servicio.getTrabajoEntregado() ? "Completado" : "En proceso"}
          </span>
          {servicio.servicioVerificado && <Award className="w-4 h-4 text-blue-500" />}
        </div>

        {/* SOLO MOSTRAR GANANCIA A ADMIN/COLABORADOR */}
        {isAdmin && (
          <div className="text-right mr-2">
            <p className="text-[9px] text-gray-400 font-bold uppercase leading-none">Utilidad</p>
            <p className="text-xs font-bold text-blue-600">
              +${(servicio.preciocobrado - (servicio.preciotutor || 0)).toLocaleString()}
            </p>
          </div>
        )}

        <button
          onClick={() => handleVerServicio(servicio)}
          className="bg-gray-900 text-white px-4 py-2 rounded-lg hover:bg-blue-600 transition-all flex items-center justify-center gap-2 text-xs font-bold shadow-sm"
        >
          <Eye size={14} />
          Ver Servicio
        </button>
      </div>

    </div>
  )
}

export default CardServicio
